// Původní název:		invia.initCarousels
// Původní umístění:	shared/js/main-desktop.js
// Status:				Používané
// Funkcionalita:		Carousely
// Použito:				HP - promo box s obrázky vpravo nahoře
//						Recenze hotelů - scrolování u tabů
// TODO BUG - poslední tab stránce Recenze hotelů není celý vidět
// TODO BUG - při procházení tabů na stránce Recenze hotelů tabulátorem se taby rozbijí
// #CHECKED jthiemel 190108


import $ from 'jquery';
import Carousel from '../../helpers/carousel';


export const init = ($target) => {
	// rotace obrazku v top promo boxu (vpravo od SF)
	$('.box-promo').each(function (i) {
		if ($(this).find('.scroll').children().length > 1) {
			var options = $.extend({
				easing: 'swing',
				animate: 500,
				pagerPages: $(this).find('.pager'),
				infinite: true,
				repeat: true,
				fullscreen: true,
				timeout: 5000,
			}, options || {});

			var carousel = new Carousel($(this).find('.scroll'), options).init();

			$(this).data('sk-carousel', carousel);
		}
	});

	// TODO - .side-tabs již asi neexistuje?
	//carousel u Tabu ?? TODO hot-tipy?
	$('.side-tabs .tabs-nav, .tabs-nav-overflow').each(function () {
		var $this = $(this);
		var index = $(this).find('.active').index();
		var pager = $this.find('.pager');
		var options = $.extend({
			position: index < 0 ? 0 : index,
			easing: 'swing',
			animate: 500,
			pagerPrev: pager.find('.prev'),
			pagerNext: pager.find('.next'),
			fullscreen: false,
			timeout: 0,
			onChange: function (obj) {
				var tabs = $this.data('sk-tabs');
				tabs && tabs.$menu.eq(obj.position).trigger('click');
			},
		}, options || {});
		var carousel = $this.data('sk-carousel');

		if (carousel) {
			var pos = carousel.position;
			carousel.destroy();
			$this.find('.pager').remove();
		}

		carousel = new Carousel($this.find('p'), options).init();

		$this.data('sk-carousel', carousel);
	});
};
